/**
 * Show warning sets with `operational_status: "Test"` next to `"Actual"` ones.
 *
 * On for local dev (`yarn dev`) and for builds with `VITE_SHOW_TEST_WARNINGS=true`
 * (acceptance CI). Off otherwise, so a production build that omits the var stays safe.
 */
export const SHOW_TEST_WARNINGS: boolean =
  import.meta.env.DEV || import.meta.env.VITE_SHOW_TEST_WARNINGS === "true";
